import { useContext, useEffect, useMemo, useState } from "react";
import { Context } from "../../App";
import { Box, TextField, Paper, Typography, Stack, Button, Grid2, Backdrop, CircularProgress } from "@mui/material";

export default function BilletEditForm({event, billet, updateBillet, close }) {
    const { setIsConnected } = useContext(Context);
    const [load, setLoad] = useState(false);
    const [nom, setNom] = useState(billet.owner.nom || '');
    const [prenom, setPrenom] = useState(billet.owner.prenom || '');

    async function handleSubmit(e) {
        e.preventDefault();
        setLoad(true);

        const query = new URLSearchParams({_id: billet._id}).toString();

        try {
            fetch(process.env.REACT_APP_API_URL.concat('/billet?' + query), {
                method: 'PATCH',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token') || localStorage.getItem('anonUserId') || ''}`
                },
                body: JSON.stringify({owner: { ...billet.owner, nom, prenom } })
            }).then(async response => {
                const token = response.headers.get('x-auth-token');
                if (token) localStorage.setItem('token', token);
                if (response.status === 401) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('user');
                    setIsConnected(false);
                    throw new Error('Unauthorized');
                }
                if (response.ok) {
                    const json = await response.json();
                    updateBillet(json);
                    close();
                } else {
                    throw new Error('Failed to create billets');
                }
            }).catch(error => {
                console.error("Error creating billets:", error);
                setLoad(false);
                throw error;
            });
        } catch (error) {
            console.error("Error in handleSubmit:", error);
            setLoad(false);
            throw error;
        }
    }


    return(
        <Box component='form' onSubmit={handleSubmit} sx={{ p: {xs:0, sm:2}, display: 'flex', flexDirection: 'column', gap: 2 }}>
            
            <Paper sx={{ display: 'flex', flexDirection: 'column', minWidth: { xs: 'auto', sm: '400px' }, borderRadius: 2, overflow: 'hidden' }}>
                <Box sx={{ px: 4, py: 2, backgroundColor: 'primary.main', color: 'white', mb: 2 }}>
                    <Typography variant="h6" fontSize={{ xs: 18, sm: 'inherit' }} color="white">{event.titre} - {billet.tarif} - {billet.price?.toFixed(2)} €</Typography>
                    <Typography variant="body1" color="secondary.main" fontSize={16}>Participant</Typography>
                </Box>

                <Box sx={{ px: { xs: 2, sm: 3 }, pb: 2 }}>
                    <TextField fullWidth label="Nom" variant="outlined" value={nom} required sx={{ mb: 2 }} onChange={(e) => setNom(e.target.value)} />
                    <TextField fullWidth label="Prénom" variant="outlined" value={prenom} required sx={{ mb: 2 }} onChange={(e) => setPrenom(e.target.value)} />
                </Box>
            </Paper>


            <Button variant="contained" type="submit" sx={{ mt: 2, color:'white', px: 2, alignSelf:'center' }}>Valider</Button>

            <Backdrop open={load}><CircularProgress/></Backdrop>
        </Box>
    )
}